import React from 'react'

const Solicitar = () => {
  return (
    <section className="text-blue body-font bg-gradient-to-r from-blue-900 via-blue-600 to-cyan-400">
      <div className="container mx-auto flex md:flex-row flex-col items-center pt-20">
        <div>
          <img
            className="w-96 mt-10"
            alt="hero"
            src="https://i.ibb.co/7b5fKFq/enthusiastic-young-asian-woman-looking-excited-at-camera-holding-money-dollars-in-hand-standing-over.png"
          />
        </div>
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <div className="lg:w-1/3 md:w-1/2 bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full md:mt-0 relative z-10">
            <h2 className="text-gray-900 text-lg mb-1 font-medium title-font">Reserva tu Asesoría</h2>
            <p className="leading-relaxed mb-5 text-gray-600">Consulta sobre nuestros planes personalizados</p>
            <input
              className="bg-white rounded border border-gray-400 focus:outline-none focus:border-cyan-600 text-base px-4 py-2 mb-4"
              placeholder="Email"
              type="email"
            />
            <textarea
              className="bg-white rounded border border-gray-400 focus:outline-none h-32 focus:border-cyan-600 text-base px-4 py-2 mb-4 resize-none"
              placeholder="Mensaje"
            />
            <button className="text-white bg-gradient-to-r from-blue-900 via-blue-600 to-cyan-400 border-0 py-2 px-6 focus:outline-none hover:from-cyan-400 hover:via-blue-600 hover:to-blue-900 rounded-full text-lg transition-colors duration-300">
              Enviar
            </button>
            <p className="text-xs text-gray-500 mt-3">Sus datos son almacenados por seguridad.</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Solicitar
